import React from 'react';

// Table skeleton — shimmering rows that match the shape of a data table
export const TableSkeleton = ({ rows = 6, columns = 5, hasAvatar = false }) => (
  <div className="skeleton-table" aria-label="Loading…" aria-busy="true">
    {Array.from({ length: rows }).map((_, i) => (
      <div key={i} className="skeleton-row">
        {Array.from({ length: columns }).map((_, j) => (
          <div key={j} className="skeleton-cell">
            {j === 0 && hasAvatar ? (
              <div className="skeleton-avatar-cell">
                <div className="skeleton-shimmer skeleton-avatar" />
                <div className="skeleton-avatar-text">
                  <div className="skeleton-shimmer skeleton-line skeleton-line--primary" />
                  <div className="skeleton-shimmer skeleton-line skeleton-line--secondary" />
                </div>
              </div>
            ) : j === columns - 1 ? (
              <div className="skeleton-shimmer skeleton-action" />
            ) : (
              <div className="skeleton-shimmer skeleton-line" style={{ width: `${60 + Math.random() * 30}%` }} />
            )}
          </div>
        ))}
      </div>
    ))}
  </div>
);

// Card skeleton — for grid/card views
export const CardSkeleton = ({ cards = 6 }) => (
  <div className="skeleton-cards" aria-label="Loading…" aria-busy="true">
    {Array.from({ length: cards }).map((_, i) => (
      <div key={i} className="skeleton-card">
        <div className="skeleton-card__header">
          <div className="skeleton-shimmer skeleton-avatar skeleton-avatar--large" />
          <div className="skeleton-card__header-text">
            <div className="skeleton-shimmer skeleton-line skeleton-line--primary" />
            <div className="skeleton-shimmer skeleton-line skeleton-line--secondary" />
          </div>
        </div>
        <div className="skeleton-card__body">
          <div className="skeleton-shimmer skeleton-line" />
          <div className="skeleton-shimmer skeleton-line skeleton-line--short" />
        </div>
        <div className="skeleton-card__footer">
          <div className="skeleton-shimmer skeleton-badge" />
          <div className="skeleton-shimmer skeleton-badge" />
        </div>
      </div>
    ))}
  </div>
);

// Stat cards skeleton — for dashboard/summary rows
export const StatsSkeleton = ({ count = 4 }) => (
  <div className="skeleton-stats" aria-label="Loading…" aria-busy="true">
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="skeleton-stat">
        <div className="skeleton-shimmer skeleton-stat__number" />
        <div className="skeleton-shimmer skeleton-stat__label" />
      </div>
    ))}
  </div>
);

export default TableSkeleton;
